import { useContext } from 'react';
import { EditorContext } from '@/features/editor/context/editor-context';
import { CustomWidgetContext } from '@/features/editor/widgets/custom-widget/shared/context';
import { filterRecommendations } from '@/features/editor/widgets/custom-widget/loading-section/recs-per-placement';
import { useFeatureBit } from '@/features/account-context';
import { FeatureBit } from '@/webapi/use-auth-api';
import { StrategyPerSlotContext } from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/context/context';
import { filterStrategiesForExternalType } from '@/features/strategies/create-strategy/strategyTypeFilter';
import { ExternalStrategyType } from '@/features/strategies/types';

export function getAvailableStrategies() {
  const { experienceState: { currentExperience } = {} } =
    useContext(EditorContext) ?? {};
  const { currentSchema } = useContext(CustomWidgetContext) ?? {};
  const strategyPerSlotCtx = useContext(StrategyPerSlotContext) as {
    isExternalStrategy?: boolean;
    externalStrategyType?: ExternalStrategyType;
  };
  const { isExternalStrategy, externalStrategyType } = strategyPerSlotCtx;
  const isNewRecAlgsEnabled = useFeatureBit(FeatureBit.NEW_REC_ALGS);

  if (isExternalStrategy) {
    return {
      options: filterStrategiesForExternalType(
        externalStrategyType || ExternalStrategyType.EMBED,
      ),
    };
  }

  return filterRecommendations(
    currentExperience?.quickPreviewPlacement,
    currentSchema?.settings?.loading,
    isNewRecAlgsEnabled,
  );
}
